import React, { memo } from 'react';

import { useTranslation } from 'react-i18next';

import { CustomModal, Flex, UiButton } from '@shared/ui';

import cls from './ModalConstructionProgress.module.css';
import { ModalConstructionProgressBody } from './ModalConstructionProgressBody/ModalConstructionProgressBody';
import { useModalConstructionProgress } from './useModalConstructionProgress';

interface ModalConstructionProgressProps {
    classes?: string;
}

export const ModalConstructionProgress = memo(({ classes }: ModalConstructionProgressProps) => {
    const {
        modalMode,
        onCancel,
        isEdit,
        formState,
        onDescription,
        onDate,
        onSubmit,
        onAddNewAlbum,
        deleteSelectedAlbum,
        onChangeAlbum,
    } = useModalConstructionProgress();

    const { t } = useTranslation();

    return (
        <CustomModal
            contentClasses={cls.modalVisible}
            isOpen={modalMode === 'constructionProgress'}
            onHideModal={onCancel}
        >
            <CustomModal.Header>
                {isEdit
                    ? t('ModalConstructionProgress.return.modalHeader.edit')
                    : t('ModalConstructionProgress.return.modalHeader.download')}
            </CustomModal.Header>
            <CustomModal.Body>
                <ModalConstructionProgressBody
                    isEdit={isEdit}
                    onDate={onDate}
                    formState={formState}
                    onDescription={onDescription}
                    onAddNewAlbum={onAddNewAlbum}
                    deleteSelectedAlbum={deleteSelectedAlbum}
                    onChangeAlbum={onChangeAlbum}
                />
            </CustomModal.Body>
            <CustomModal.Footer>
                <Flex fullWidth justify="between">
                    <UiButton
                        btnColor="secondary"
                        onClick={onCancel}
                        btnText={t('ModalConstructionProgress.return.modalFooter.button.cancel')}
                    />
                    <UiButton
                        onClick={onSubmit}
                        btnText={t('ModalConstructionProgress.return.modalFooter.button.submit')}
                    />
                </Flex>
            </CustomModal.Footer>
        </CustomModal>
    );
});
